interface StoreContextItem {
  id?: number | string
}

export const canAccessStoreRoute = (
  requestedPath = '',
  stores: StoreContextItem[] = []
): boolean => {
  const match = /^\/dashboard\/stores\/([^/]+)/.exec(requestedPath)
  if (!match) {
    return true
  }

  const storeIdentifier = match[1]
  if (storeIdentifier === 'create' || storeIdentifier === 'setup') {
    return true
  }

  if (storeIdentifier === undefined || storeIdentifier.length === 0) {
    return false
  }

  return stores.some(
    (store) =>
      store.id === storeIdentifier ||
      (typeof store.id === 'number' && store.id.toString() === storeIdentifier)
  )
}
